module.exports = __webpack_public_path__ + "static/img/product_img5.fb2aca9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_img5.png
// module id = EMLU
// module chunks = 0